import React from 'react';
import _ from 'lodash';
import { Row } from '@mlc/web-ui-toolkit';
import { FieldArray, FieldArrayRenderProps } from 'formik';
import { AccountFilterElements } from '../AccountFilterElements';
import * as Styled from '../../styled';
import {
	AccountType,
	handleAllSelectionForCheckboxArray,
} from '../../handleAllSelectionForCheckboxArray';

interface Props {
	accountType: string[];
}

const accountTypes: AccountType[] = [
	{
		value: 'all',
		label: 'All',
		dataId: AccountFilterElements.allAccountCheckboxFilterId,
	},
	{
		value: 'plan',
		label: 'Plans',
		dataId: AccountFilterElements.plansAccountCheckboxFilterId,
	},
	{
		value: 'client',
		label: 'Individuals',
		dataId: AccountFilterElements.individualsAccountCheckboxFilterId,
	},
];

const AccountTypeFilter = (props: Props) => (
	<React.Fragment>
		<FieldArray
			name="accountType"
			validateOnChange={true}
			key="accountTypeFilter"
			render={(arrayHelpers: FieldArrayRenderProps) => {
				return (
					<Row>
						<Styled.CheckboxSubCol md="6" sm="12">
							{_.map(accountTypes, type => {
								return (
									<Styled.FilterCheckbox
										key={type.value}
										name="accountType"
										label={type.label}
										value={type.value}
										data-id={type.dataId}
										checked={_.includes(props.accountType, type.value)}
										onChange={(e: any) => {
											handleAllSelectionForCheckboxArray(
												e,
												type,
												arrayHelpers,
												props.accountType
											);
										}}
									/>
								);
							})}
						</Styled.CheckboxSubCol>
					</Row>
				);
			}}
		/>
	</React.Fragment>
);
AccountTypeFilter.isGroupedFormField = true;
export default AccountTypeFilter;
